import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SpinnerService {
  visibility: BehaviorSubject<boolean>;

  constructor() {
    this.visibility = new BehaviorSubject(false);
  }

  showSpinner() {
    this.visibility.next(true);
  }

  hideSpinner() {
    this.visibility.next(false);
  }
}
